export default __webpack_public_path__ + "static/media/hot-sale.fc2c4d54.svg";